var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-tab-detail"},[_vm._v(" 商品详情（待对接修改） ")])}
var staticRenderFns = []

export { render, staticRenderFns }